export function parseMoney(s: string): number {
  const n = Number.parseFloat(s)
  if (Number.isNaN(n)) {
    throw new Error(`parseMoney: invalid decimal string: ${s}`)
  }
  return n
}
